import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {createSelector} from "reselect";

import {topoUtils} from '../utils/topo-utils';
import {geoUtils} from '../utils/geo-utils';

const topo = topoUtils.getNationalTopography();

/**
 * Component for drawing the selected or hovered state borders on the state map.
 *
 * The borders are separated so that the can be drawn on top on the colored paths
 * and dont interfere with mouse events.
 *
 * Stroke color is defined inline to prevent css dependency during export.
 *
 * @property height - height of the parent svg in pixels for placement
 * @property width - width of the parent svg in pixels for placement
 * @property strokeColor - string hex color value for the drawn path stroke def. #373737
 *
 * @example
 * return (
 *   <UsaStateBorders
 *     width={500}
 *     height={500}
 *   />
 * )
 */
export default class UsaStateBorders extends PureComponent {

  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    strokeColor: PropTypes.string
  };

  static defaultProps = {
    strokeColor: '#373737'
  }

  getWidth = (props) => props.width
  getHeight = (props) => props.height

  getPath = createSelector(
    [this.getWidth, this.getHeight],
    (width, height) => geoUtils.getAlbersUsaPath(width, height)
  )

  getStrokeWidth = createSelector(
    [this.getWidth],
    (width) => width > 500 ? 1 : 0.75
  )

  render() {
    const {strokeColor} = this.props;
    const path = this.getPath(this.props);
    const strokeWidth = this.getStrokeWidth(this.props);

    return (
      <g className="UsaStateBorders">
        <path
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          d={path(topo.borders)}
        />
      </g>
    )
  }
}
